exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".table>tbody>tr>td{\r\n    padding: 2px;\r\n    font-size: 10px;\r\n}\r\ninput{\r\n    width: 100%;\r\n    font-size: 10px;\r\n}\r\n.btn{\r\n    margin:2% 0;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/xampp/htdocs/playitadmin_frontend/src/app/builds/builds.component.css
// module id = ../../../../../src/app/builds/builds.component.css
// module chunks = main